module.exports = __webpack_public_path__ + "media/components/live/rdc/images/listing-promotion-3732ed9a202136308fe3075f112c3e21.png";